module.exports = __webpack_public_path__ + "static/media/undo.82d2ddf3.svg";